import React from 'react';
import { connect } from 'react-redux';
import Form from '../../FormsTemplate';
import { FormNames } from '../../Forms.constants';

import UserInfoSection from '../../Sections/UserInfoSection/UserInfoSection';
import ManufacturerModelSection from '../../Sections/ManufacturerModelSection/ManufacturerModelSection';
import DeviceTypesSection from '../../Sections/DeviceTypesSection/DeviceTypesSection';
import HMISection from '../../Sections/HMISection/HMISection';
import VisualInspectSection from '../../Sections/VisualInspectSection/VisualInspectSection';
import TestResultSection from '../../Sections/TestResultSection/TestResultSection';
import AsFoundTestTableSection from '../../Sections/AsFoundTestTableSection/AsFoundTestTableSection';
import NoteSection from '../../Sections/NoteSection/NoteSection';
import BorderedBox from '../../BorderedBox';
import ToleranceInstrumentEUCommentSection from '../../Sections/ToleranceInstrumentEUComment/ToleranceInstrumentEUComment';
import SetpointSection from '../../Sections/SetpointSection/SetpointSection';
import TestResultComponent from '../../Sections/TestResultComponent/TestResultComponent';

const P861Form = (props) => (
    <Form
        formName={FormNames.P861}
    >
        <UserInfoSection />
        <ManufacturerModelSection />
        <DeviceTypesSection />
        <HMISection />
        <VisualInspectSection />
        <BorderedBox>
            <AsFoundTestTableSection />
        </BorderedBox>
        <ToleranceInstrumentEUCommentSection />
        <BorderedBox>
            <SetpointSection />
        </BorderedBox>
        <TestResultSection />
        <TestResultComponent />
        <NoteSection />
    </Form>
);

const mapStateToProps = ({ Forms }) => ({
    selectedTag: Forms.selectedTag,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P861Form);
